// Configuration des endpoints de l'API
export const API_ENDPOINTS = {
  // Endpoints pour les demandes
  DEMANDES: {
    LIST: (page = 1) => `/be/admin/demandes/?page=${page}`,
    DETAIL: (id) => `/be/admin/demandes/${id}/`,
    CREATE: '/be/admin/demandes/',
    UPDATE: (id) => `/be/admin/demandes/${id}/`,
    DELETE: (id) => `/be/admin/demandes/${id}/`,
  },

  // Endpoints pour les projets
  PROJECTS: {
    LIST: (page = 1) => `be/admin/projets/?page=${page}`,
    DETAIL: (id) => `be/admin/projets/${id}/`,
    CREATE: 'be/admin/projets/',
    UPDATE: (id) => `be/admin/projets/${id}/`,
    DELETE: (id) => `be/admin/projets/${id}/`,
  },

  // Endpoints pour les documents
  DOCUMENTS: {
    LIST: (page = 1) => `/be/admin/documents/?page=${page}`,
    DETAIL: (id) => `/be/admin/documents/${id}/`,
    UPLOAD: '/be/admin/documents/',
    DOWNLOAD: (id) => `/be/admin/documents/${id}/download/`,
  },

  // Endpoints pour les réponses
  RESPONSES: {
    LIST: (page = 1) => `/be/my-responses/?page=${page}`,
    LIST_BY_DEMANDE: (demandeId) => `/be/my-responses/?demande=${demandeId}`,
    DETAIL: (id) => `/be/my-responses/${id}/`,
    CREATE: '/be/my-responses/',
    UPDATE: (id) => `/be/my-responses/${id}/`,
    DELETE: (id) => `/be/my-responses/${id}/`,
  },

  // Endpoints pour les étapes
  STEPS: {
    LIST: (page = 1) => `be/admin/steps/?page=${page}`,
    LIST_BY_PROJECT: (projectId) => `be/admin/steps/?project=${projectId}`,
    DETAIL: (id) => `be/admin/steps/${id}/`,
    CREATE: 'be/admin/steps/',
    UPDATE: (id) => `be/admin/steps/${id}/`,
    DELETE: (id) => `be/admin/steps/${id}/`,
  },

  // Endpoints pour les sections
  SECTIONS: {
    LIST: (page = 1) => `be/admin/sections/?page=${page}`,
    LIST_BY_STEP: (stepId) => `be/admin/sections/?step=${stepId}`,
    DETAIL: (id) => `be/admin/sections/${id}/`,
    CREATE: 'be/admin/sections/',
    UPDATE: (id) => `be/admin/sections/${id}/`,
    DELETE: (id) => `be/admin/sections/${id}/`,
  },

  // Endpoints pour les contenus
  CONTENTS: {
    LIST: (page = 1) => `be/admin/contents/?page=${page}`,
    LIST_BY_SECTION: (sectionId) => `be/admin/contents/?section=${sectionId}`,
    DETAIL: (id) => `be/admin/contents/${id}/`,
    CREATE: 'be/admin/contents/',
    UPDATE: (id) => `be/admin/contents/${id}/`,
    DELETE: (id) => `be/admin/contents/${id}/`,
  },

  // Endpoints pour les utilisateurs
  USERS: {
    LIST: (page = 1) => `users/?page=${page}`,
    DETAIL: (id) => `users/${id}/`,
    ME: 'users/me/',
  },

  // Endpoints pour l'authentification
  AUTH: {
    LOGIN: 'auth/magento/oauth/',
    REFRESH: 'api/token/refresh/',
    LOGOUT: 'auth/logout/',
  }
};